import React from "react";
import {
  Datagrid,
  TextField,
  List,
  ReferenceField,
  ShowButton,
} from "react-admin";
import AssociateButton from "../AssociateButton";

const WebhookList = ({ orgId, filter, can_remove, can_add }) => {
  return (
    <List title=" " basePath={"/webhooks"} resource="webhooks" filter={filter}
      component={"div"}>
      <Datagrid>
        <ReferenceField
          label="Organization"
          source="org_id"
          reference="organizations"
          link="show"
        >
          <TextField source="name" />
        </ReferenceField>
        <TextField source="url" />
        <TextField label="Event Type" source="eventType" />
        {can_add ? (
          <AssociateButton
            orgId={orgId}
            type="webhook"
            mode="_to_add"
            title="Add"
          />
        ) : null}
        {can_remove ? (
          <AssociateButton
            orgId={orgId}
            type="webhook"
            mode="_to_remove"
            title="Remove"
          />
        ) : null}
        <ShowButton />
      </Datagrid>
    </List>
  );
};

export default WebhookList;